import axios from "axios";
import { attachTrackingHeader } from "@/lib/trackingContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const PLATFORM_TOKEN_KEY = "samtwo_platform_token";

export const getPlatformToken = () => localStorage.getItem(PLATFORM_TOKEN_KEY);
export const setPlatformToken = (t) => localStorage.setItem(PLATFORM_TOKEN_KEY, t);
export const clearPlatformToken = () => localStorage.removeItem(PLATFORM_TOKEN_KEY);

// Subscriber music API — attaches the platform token when present.
export const musicClient = axios.create({ baseURL: `${API}/music` });
musicClient.interceptors.request.use((cfg) => {
  const t = getPlatformToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// Generic subscriber platform API (watch, clips, comments, etc.).
export const platformClient = axios.create({ baseURL: API });
platformClient.interceptors.request.use((cfg) => {
  const t = getPlatformToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// Platform auth (subscriber login / me / logout).
export const authClient = axios.create({ baseURL: `${API}/auth`, withCredentials: true });
authClient.interceptors.request.use((cfg) => {
  const t = getPlatformToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// Silent token reissue: the backend attaches X-Refreshed-Token when a live token
// nears expiry; persist it so long-lived active sessions never get logged out.
const captureRefreshedToken = (res) => {
  const fresh = res?.headers?.["x-refreshed-token"];
  if (fresh) setPlatformToken(fresh);
  return res;
};
[musicClient, platformClient, authClient].forEach((c) => {
  c.interceptors.response.use(captureRefreshedToken, (err) => Promise.reject(err));
  attachTrackingHeader(c);
});

// Like count display: exact under 1k, "1.2K", "2.3M".
export const fmtCount = (n) => {
  if (n == null) return "0";
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1).replace(/\.0$/, "")}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(1).replace(/\.0$/, "")}K`;
  return `${n}`;
};
